import React, { useEffect } from 'react';
import "./Home2.css";

const Home2 = () => {
  useEffect(() => {
    const items = document.querySelectorAll('.home2-grid1');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    items.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className='home2-main'>
      <div className="home2-container">
        <div className="home2-grid1">
          <div className="home2-head">
            <h1>14+ yrs</h1>
          </div>
          <div className="home2-text">
            <span>Working experience</span>
          </div>
        </div>

        <div className="home2-grid1">
          <div className="home2-head">
            <h1>2,500+</h1>
          </div>
          <div className="home2-text">
            <span>MOFSL partner network</span>
          </div>
        </div>

        <div className="home2-grid1">
          <div className="home2-head">
            <h1>100%</h1>
          </div>
          <div className="home2-text">
            <span>Advisory transparency</span>
          </div>
        </div>

        <div className="home2-grid1">
          <div className="home2-head">
            <h1>Local</h1>
          </div>
          <div className="home2-text">
            <span>Patiala, Punjab office</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home2;